export enum EServiceProviderOrderType {
  AUTOMATIC = 'automatic',
  B2B_ACCOUNT = 'b2b_account',
  PARTNER_FEEDBACK = 'partner_feedback',
  ESTIMATE = 'estimate',
}

export enum ECommissionType {
  REAL = 'real',
  ESTIMATED = 'estimated',
  MANUAL = 'manual'
}

export interface IServiceProviderMonthlyMetric {
  serviceProviderId: number;
  serviceProviderName: string;
  year: number;
  month: number;
  currency: string;
  scopeSize: number | null;
  visit: number | null;
  purchaseIntent: number | null;
  orderType: EServiceProviderOrderType;
  orderCount: number | null;
  gmv: number | null;
  commissionRate: number;
  commissionType: ECommissionType;
  commissionManualValue: number | null;
  isClosed: boolean;
}
